import { Fragment, useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useHttp from "hooks/use-http";

import { Grid } from "@mui/material";

import { getMessageUserByIdRequest } from "api/requests";

import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import BackButton from "components/shared/BackButton";

import { StyledStack, StyledTitle, TextField } from "./MessageDetails.style";

export default function MessageDetails() {
  const params = useParams();
  const { request, loading, setLoading } = useHttp();

  const [messageInfo, setMessageInfo] = useState({ data: [], count: 0 });
  const [jDate, setJDate] = useState("");

  const getMessageInfo = useCallback(async () => {
    setLoading(true);
    const res = await request({
      url: getMessageUserByIdRequest,
      values: params.messageId,
    });
    setLoading(false);

    if (res) {
      if (res.count < 1) {
        return setMessageInfo({
          count: res.count,
          data: [{ content: "هیچ اطلاعاتی یافت نشد" }],
        });
      }
      setMessageInfo(res);
      setJDate(res.created_at.jdate.split(" ")[0]);
    }
  }, [request, params.messageId]);

  useEffect(() => {
    getMessageInfo();
  }, [getMessageInfo]);

  return (
    <DrawerCM title="نمایش پیام">
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container my={2}>
            <Grid item mt={3} xs={12}>
              <BackButton />
            </Grid>
            <StyledStack>
              <StyledTitle>نمایش اطلاعات پیام</StyledTitle>
              <Grid container>
                <Grid item md={12} xs={12} p={1.5}>
                  <TextField>
                    <span style={{ color: "gray" }}>
                      نام و نام خانوادگی کاربر:
                    </span>
                    <div style={{ padding: "15px 0px 0px 0px" }}>
                      {messageInfo.full_name}
                    </div>
                  </TextField>
                </Grid>
                <Grid item md={6} xs={12} p={1.5}>
                  <TextField>
                    <span style={{ color: "gray" }}>ایمیل:</span>
                    <div style={{ padding: "15px 0px 0px 0px" }}>
                      {messageInfo.email}
                    </div>
                  </TextField>
                </Grid>
                {/* <Grid item md={6} xs={12} p={1.5}>
                  <TextField>
                    <span style={{ color: "gray" }}>شماره تماس:</span>
                    <div style={{ padding: "15px 0px 0px 0px" }}>
                      {messageInfo.phone_number}
                    </div>
                  </TextField>
                </Grid> */}
                <Grid item md={6} xs={12} p={1.5}>
                  <TextField>
                    <span style={{ color: "gray" }}>تاریخ ارسال:</span>
                    <div style={{ padding: "15px 0px 0px 0px" }}>{jDate}</div>
                  </TextField>
                </Grid>
                <Grid item xs={12} p={1.5}>
                  <TextField>
                    <span style={{ color: "gray" }}>شرح درخواست:</span>
                    <div style={{ padding: "15px 0px 0px 0px" }}>
                      {messageInfo.message}
                    </div>
                  </TextField>
                </Grid>
              </Grid>
            </StyledStack>
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}
